import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RealityCheckStoreState } from '../utils/types';
import reducerRegistry from '@comeon/reducer-registry';

const REDUCER_NAME = 'realityCheckNew';

const initialState: RealityCheckStoreState = {
	currentNotification: null,
	error: null,
	gamePlayStarted: false,
	timerId: undefined,
	cooloffEndTime: null,
	cooloffPeriodOn: false,
	updateDuration: false,
	ongoingGameRound: false,
	realityCheckTimeReached: false
};

const realityCheckNewSlice = createSlice({
	name: REDUCER_NAME,
	initialState,
	reducers: {
		setGamePlayStarted(state, action: PayloadAction<boolean>) {
			return {
				...state,
				gamePlayStarted: action.payload
			};
		},
		setActiveRCTimerId(state, action: PayloadAction<NodeJS.Timeout | undefined>) {
			return {
				...state,
				timerId: action.payload
			};
		},
		hideNotification(state) {
			return {
				...state,
				showNotification: false
			};
		},
		setUpdateDuration(state, action: PayloadAction<boolean>) {
			return {
				...state,
				updateDuration: action.payload
			};
		},
		setCooloffPeriodOn(state, action: PayloadAction<boolean>) {
			return {
				...state,
				cooloffPeriodOn: action.payload
			};
		},
		setCooloffEndTime(state, action: PayloadAction<number | null>) {
			return {
				...state,
				cooloffEndTime: action.payload
			};
		},
		setOngoingGameRound(state, action: PayloadAction<boolean>) {
			return {
				...state,
				ongoingGameRound: action.payload
			};
		},
		setRealityCheckTimeReached(state, action: PayloadAction<boolean>) {
			return {
				...state,
				realityCheckTimeReached: action.payload
			};
		}
	}
});

export const setGamePlayStartedSelector = (state: { realityCheckNew: RealityCheckStoreState }) =>
	state.realityCheckNew.gamePlayStarted as boolean;
export const selectUpdateDurationSelector = (state: { realityCheckNew: RealityCheckStoreState }) =>
	state.realityCheckNew.updateDuration as boolean;
export const selectTimerId = (state: { realityCheckNew: RealityCheckStoreState }) =>
	(state.realityCheckNew.timerId as NodeJS.Timeout) || undefined;
export const selectCooloffPeriodOn = (state: { realityCheckNew: RealityCheckStoreState }) =>
	state.realityCheckNew.cooloffPeriodOn as boolean;
export const selectCooloffEndTime = (state: { realityCheckNew: RealityCheckStoreState }) =>
	state.realityCheckNew.cooloffEndTime as number;
export const selectOngoingGameRoundSelector = (state: { realityCheckNew: RealityCheckStoreState }) =>
	state.realityCheckNew.ongoingGameRound as boolean;
export const selectRealityCheckTimeReachedSelector = (state: { realityCheckNew: RealityCheckStoreState }) =>
	state.realityCheckNew.realityCheckTimeReached as boolean;

export const {
	setGamePlayStarted,
	setActiveRCTimerId,
	hideNotification,
	setCooloffPeriodOn,
	setCooloffEndTime,
	setUpdateDuration,
	setOngoingGameRound,
	setRealityCheckTimeReached
} = realityCheckNewSlice.actions;

reducerRegistry.register(REDUCER_NAME, realityCheckNewSlice.reducer);

export default realityCheckNewSlice.reducer;
